
/* injects from baggage-loader */

import Helpers from "../helperFunctions";
import { handleGameUpdate2 } from "../asianHelpers";

export const handleGameListStandartSubscriptionData = (data, selectedSport) => {
    let sport = Object.keys(data.sport).length && Helpers.firstElement(data),
        regions = sport && Helpers.firstElement(sport) && Helpers.firstElement(sport).region,
        competition = regions && (() => {
            return Object.keys(regions).reduce((collected, regionId) => {
                let region = regions[regionId],
                    competitions = region.competition;

                Object.values(competitions).forEach((current) => {
                    Object.values(current.game).forEach((game) => {
                        game.regionOrder = region.order;
                        game.regionAlias = region.alias;
                        game.regionId = region.id;
                        game.competitionName = current.name;
                        game.competitionId = current.id;
                        game.competitionOrder = current.order;
                    });
                });

                return {
                    ...collected,
                    ...competitions
                };
            }, {});
        })(),
        games = (competition && Object.keys(competition).length > 1)
            ? Object.values(competition).reduce((collected, current) => {
                return collected.concat(Helpers.objectToArray(current.game));
            }, [])
            : Helpers.firstElement(competition) && Helpers.firstElement(competition).game && Helpers.objectToArray(Helpers.firstElement(competition).game);

    return games && games.map((game) => {
        return handleGameUpdate2(game, selectedSport);
    }).filter(game => Boolean(game)).reduce((current, game) => {
        current[game.id] = game;
        return current;
    }, {});
};